const templates = {
  title: 'Predloge',
  create: 'Ustvari predlogo',
  edit: 'Uredi predlogo',
  duplicate: 'Podvoji',
  duplicateTemplate: 'Podvoji predlogo',
  templateDuplicated: 'Predloga podvojena',
  templateName: 'Ime predloge',
  templateFile: 'Datoteka predloge',
  templateNamePlaceholder: 'SOAP zapis, Začetna konzultacija',
  templateLanguage: 'Jezik predloge',
  sections: 'Razdelki',
  addSection: 'Dodaj razdelek',
  sectionTitle: 'Naslov razdelka',
  sectionTitlePlaceholder: 'Subjektivno, Ocena, Načrt',
  sectionInstructions: 'Navodila za umetno inteligenco',
  sectionInstructionsPlaceholder: 'Navodila za vsebino tega razdelka...',
  save: 'Shrani',
  templateCreated: 'Predloga ustvarjena',
  cancel: 'Prekliči',
  noSections: 'Še ni razdelkov. Dodajte prvi razdelek za začetek.',
  noTemplates: 'Še ni predlog',
  noTemplatesDescription: 'Ustvarite svojo prvo predlogo za začetek.',
  section_one: '{{count}} razdelek',
  section_two: '{{count}} razdelka',
  section_few: '{{count}} razdelki',
  section_other: '{{count}} razdelkov',
  publicTemplate: 'Javna predloga',
  publicTemplateDescription: 'Naredite to predlogo vidno vsem uporabnikom',
  personalTemplates: 'Moje predloge',
  publicTemplates: 'Javne predloge',
  separator: ' • ',
  loading: 'Nalaganje...',
  templateUpdated: 'Predloga posodobljena',
  invalidTemplateId: 'Neveljaven ID predloge',
  templateNotFound: 'Predloga ni najdena',
  validation: {
    templateNameRequired: 'Ime predloge je obvezno',
    languageRequired: 'Jezik predloge je obvezen',
    atLeastOneSectionRequired: 'Vsaj en razdelek je obvezen',
    onlyDocxFilesAllowed: 'Samo DOCX datoteke so dovoljene',
    sectionTitleRequired: 'Naslov razdelka je obvezen',
    sectionInstructionsRequired: 'Navodila za razdelek so obvezna',
    fileRequired: 'Datoteka je obvezna',
  },
  public: 'Javno',
  private: 'Zasebno',
  collapse: 'Strni',
  expandAll: 'Razširi vse',
  collapseAll: 'Strni vse',
  deleteConfirmTitle: 'Izbriši predlogo',
  deleteConfirmDescription:
    'Ali ste prepričani, da želite izbrisati "{{name}}"? Tega dejanja ni mogoče razveljaviti.',
  delete: 'Izbriši',
};

export default templates;
